// extracted by mini-css-extract-plugin
export default {"th":"WalletSummary_th__J5lui","td":"WalletSummary_td__Gsl0R","smaller":"WalletSummary_smaller__Mn6zO"};